import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { pathgen } from 'object-path-generator';
import { BulletListItem, IconButton, Typography } from 'seagull';
import { Edit, Trash } from 'seagull/icons';
import styles from './ServiceItem.module.scss';
export const ServiceItemTestIds = pathgen('ServiceItemTestIds');
const ActionIconButton = (param)=>{
    let { testId, icon, onClick, bi } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        bi: bi,
        testId: testId,
        type: "button",
        size: "small",
        noPadding: true,
        skin: "transparent",
        onClick: onClick,
        children: icon
    });
};
const ServiceItem = (param)=>{
    let { includedService, mode, onEdit, onDelete, testId, isArchived, isDragActive, dragHandle, transparentBackground } = param;
    function renderActionButtons() {
        if (isDragActive) return null;
        switch(mode){
            case 'editAndDelete':
                var _includedService_serviceTemplateId, _includedService_serviceTemplateId1;
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ActionIconButton, {
                            bi: {
                                name: 'edit_included_service',
                                data: {
                                    service_template_id: (_includedService_serviceTemplateId = includedService.serviceTemplateId) !== null && _includedService_serviceTemplateId !== void 0 ? _includedService_serviceTemplateId : ''
                                }
                            },
                            testId: ServiceItemTestIds.EditButton(includedService.serviceTemplateId || ''),
                            icon: /*#__PURE__*/ _jsx(Edit, {}),
                            onClick: ()=>onEdit(includedService)
                        }),
                        /*#__PURE__*/ _jsx(ActionIconButton, {
                            bi: {
                                name: 'delete_included_service',
                                data: {
                                    service_template_id: (_includedService_serviceTemplateId1 = includedService.serviceTemplateId) !== null && _includedService_serviceTemplateId1 !== void 0 ? _includedService_serviceTemplateId1 : ''
                                }
                            },
                            testId: ServiceItemTestIds.DeleteButton(includedService.serviceTemplateId || ''),
                            icon: /*#__PURE__*/ _jsx(Trash, {
                                size: 20
                            }),
                            onClick: ()=>onDelete(includedService)
                        })
                    ]
                });
            case 'delete':
                var _includedService_serviceTemplateId2;
                return /*#__PURE__*/ _jsx(ActionIconButton, {
                    bi: {
                        name: 'delete_included_service',
                        data: {
                            service_template_id: (_includedService_serviceTemplateId2 = includedService.serviceTemplateId) !== null && _includedService_serviceTemplateId2 !== void 0 ? _includedService_serviceTemplateId2 : ''
                        }
                    },
                    testId: ServiceItemTestIds.DeleteButton(includedService.serviceTemplateId || ''),
                    icon: /*#__PURE__*/ _jsx(Trash, {
                        size: 20
                    }),
                    onClick: ()=>onDelete(includedService)
                });
            case 'readonly':
                return null;
        }
    }
    const content = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            dragHandle,
            /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                variant: "paragraph1",
                className: styles.serviceItemName,
                testId: ServiceItemTestIds.ServiceItemName(includedService.serviceTemplateId || ''),
                children: "".concat(includedService.name).concat(isArchived ? ' (Archived)' : '')
            }),
            renderActionButtons()
        ]
    });
    const serviceItemClassName = cn(styles.serviceItem, transparentBackground && styles.transparent);
    if (dragHandle) {
        return /*#__PURE__*/ _jsx("div", {
            "data-testid": testId,
            className: serviceItemClassName,
            children: content
        });
    }
    return /*#__PURE__*/ _jsx(BulletListItem, {
        custom: true,
        testId: testId,
        className: serviceItemClassName,
        children: content
    });
};
export default ServiceItem;
